import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';

const TNO_URL = 'https://www.tnonetwork.com';

function openWhatsAppDudas() {
  const phoneNumber = '+584222020113';
  const message = 'Hola, tengo dudas sobre el curso de Oratoria Estratégica en TNO. ¿Me pueden dar información?';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
}

const CierreContacto = () => {
  return (
    <Box py={{ xs: 3, md: 4 }} textAlign="center">
      <Box component={Typography} fontWeight={900} variant="h4" gutterBottom>
        ¡Es tu momento de brillar!
      </Box>
      <Typography
        variant="body1"
        color="textSecondary"
        sx={{ maxWidth: 860, mx: 'auto', mb: 3 }}
      >
        Los cupos son estrictamente limitados para asegurar atención personalizada. No dejes que el mundo se pierda lo
        que tienes que decir.
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
        <Box
          component="a"
          href={TNO_URL}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: 'inherit', fontWeight: 800, textDecoration: 'underline' }}
        >
          TNO Network
        </Box>{' '}
        — Las Mercedes, Caracas.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="large"
        startIcon={<WhatsAppIcon />}
        onClick={openWhatsAppDudas}
      >
        Chatear por WhatsApp 0422-2020113
      </Button>
    </Box>
  );
};

export default CierreContacto;

